module.exports = __webpack_public_path__ + "img/linyangtitle.01e793af.png";